import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsService } from '@spartacus/core';
import { CustomCmsItemComponentData } from '../custom-cms-item/custom-cms-item.model';
import { CustomCategoryCarouselComponentData } from './custom-category-carousel.model';

@Component({
  selector: 'app-custom-category-carousel',
  templateUrl: './custom-category-carousel.component.html',
  styleUrls: ['./custom-category-carousel.component.scss'],
  standalone: false
})
export class CustomCategoryCarouselComponent {

  animation = 'swipe';

  constructor(
    protected componentData: CmsComponentData<CustomCategoryCarouselComponentData>,
    private cmsService: CmsService
  ) {}

  data$ = this.componentData.data$.pipe(map(component => component));
  items$: Observable<Observable<CustomCmsItemComponentData>[]> = this.componentData.data$.pipe(
    map((data) => data.items?.trim().split(' ').map((codes: string) => this.cmsService.getComponentData(codes)))
  );
}
